<!-- Actions with category search view component -->
<!-- <app-actions-with-category-search-view [title]="stagNameToShow()" [description]="description()"
  [logoFileNameView]="tag().logoFileNameView" [defaultFilter]="defaultFilter()">
</app-actions-with-category-search-view> -->

<div class="container-md" *ngIf="tag().tagTranslatedList.length > 0">
  <fa-icon
    *ngIf="
      tag().logoFileNameView == null ||
      title() === '' ||
      description() === ''
    "
    class="me-2"
    [icon]="faTags"
  ></fa-icon>
  <span
    *ngIf="
    tagTranslated() && (
      tag().logoFileNameView == null ||
      title() === '' ||
      description() === ''
)"
    class="fw-bold"
    >{{ "IDS_TAG_RESULTS" | translate }}</span
  >
  <span
    *ngIf="
      tagTranslated() &&
      tagNameToShow() !== '' &&
      (tag().logoFileNameView == null ||
        title() === '' ||
        description() === '')
    "
    class="ms-2 my-3 searchTerm"
    >"{{ tagNameToShow() }}"</span
  >
</div>

<app-tags-component-slideshow
  *ngIf="tag()"
  [img]="tag().logoFileNameView"
  [alt]="tag().postedFileName"
  [title]="tagTranslated()?.title"
/>

<div class="container-md" *ngIf="!!tagTranslated()">
  <div class="row mb-4" *ngIf="description()">
    <div class="col-12">
      <div
        class="static-page"
        [innerHTML]="description()"
      ></div>
    </div>
  </div>
</div>

<div class="main-container">
  <div class="container-md relative">
    <div class="row pt-4 pb-2 justify-content-between sticky">
      <div class="col-6 col-md-4 h-100">
        <p-button
          [label]="'IDS_ARTICLE_CATEGORY' | translate"
          (onClick)="onOpenCategoryModal()"
          severity="primary"
        />
      </div>
      <div class="col-6 col-md-4 d-flex justify-content-end">
        <p-button
          [label]="'IDS_MY_AUCTIONS' | translate"
          severity="primary"
          (onClick)="onFilterFavorites()"
        >
          <ng-template pTemplate="icon">
            <fa-icon [icon]="faHeart"
              [class.text-danger]="this.filterService?.filters?.onlyFavorites"
            ></fa-icon>
          </ng-template>
        </p-button>
      </div>
      <div class="col-md-4 mt-small-2 d-flex justify-content-end">
        <input
          #searchInputHeader
          id="searchInputHeader"
          type="search"
          [(ngModel)]="searchText"
          [placeholder]="'IDS_GLOBAL_SEARCH' | translate"
          aria-span="Search"
          (keydown.enter)="onSearch()"
        />
        <button
          title="search"
          id="searchButton"
          type="button"
          (click)="onSearch()"
        >
          <fa-icon [icon]="faSearch"></fa-icon>
        </button>
      </div>
    </div>
    <app-bid-search-result
      *ngIf="isLoaded()"
      [showHeader]="false"
      [memorabidAuctions]="auctionDownloadedService.memorabidAuctions"
      [isBidBoxLarge]="true"
      [idAuctionList]="idAuctionList()"
      [startingAuctionNumber]="10000"
    >
      <ng-template #filter />
    </app-bid-search-result>
  </div>
</div>
